import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import PageTransition from '../../components/PageTransition';
import SafeIcon from '../../common/SafeIcon';
import { FiBriefcase, FiChevronRight, FiPlus } from 'react-icons/fi';

const OrgPicker = () => {
  const { userOrgs, selectOrg } = useAuth();
  const navigate = useNavigate();

  const handleSelect = (org) => {
    selectOrg(org);
    navigate('/projects');
  };

  return (
    <PageTransition className="flex items-center justify-center bg-gray-50 min-h-screen p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <h1 className="text-3xl font-extrabold text-gray-900 tracking-tight">Select Organization</h1>
          <p className="text-gray-500 mt-2 font-medium">Which workspace would you like to access today?</p>
        </div>

        <div className="space-y-3">
          {userOrgs.map((org) => (
            <button
              key={org.id}
              onClick={() => handleSelect(org)}
              className="w-full flex items-center justify-between p-5 bg-white border border-gray-100 rounded-2xl hover:shadow-xl hover:shadow-indigo-500/5 hover:border-indigo-200 transition-all group"
            >
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-indigo-50 rounded-xl flex items-center justify-center text-indigo-600">
                  <SafeIcon icon={FiBriefcase} className="text-xl" />
                </div>
                <div className="text-left">
                  <p className="font-bold text-gray-900 group-hover:text-indigo-600 transition-colors">{org.name}</p>
                  <p className="text-xs text-gray-500 font-medium uppercase tracking-wider">{org.role}</p>
                </div>
              </div>
              <SafeIcon icon={FiChevronRight} className="text-gray-300 group-hover:text-indigo-500 transition-colors" />
            </button>
          ))}

          <button className="w-full flex items-center gap-4 p-5 bg-gray-50 border border-dashed border-gray-300 rounded-2xl hover:bg-gray-100 transition-all group mt-6">
            <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center text-gray-400 group-hover:text-indigo-600 transition-colors">
              <SafeIcon icon={FiPlus} className="text-xl" />
            </div>
            <p className="font-bold text-gray-500 group-hover:text-gray-700 transition-colors">Create new organization</p>
          </button>
        </div>
      </div>
    </PageTransition>
  );
};

export default OrgPicker;